import { Skeleton } from '@shared/components/shadcn';
import type { LayoutVariant } from '../../casino/types/types';
import { createCardClasses, createContainerClasses } from './styles';

type LayoutSkeletonProps = {
  layoutVariant: LayoutVariant;
};

function LayoutSkeleton({ layoutVariant }: LayoutSkeletonProps) {
  const containerClasses = createContainerClasses();
  const cardClasses = createCardClasses();

  const GameCardSkeleton = () => {
    if (layoutVariant === 'list') {
      return (
        <div className={cardClasses({ variant: layoutVariant })}>
          <div className="relative w-full h-full rounded-lg overflow-hidden flex">
            <div className="h-full aspect-square shrink-0">
              <Skeleton className="w-29 h-20.5 rounded-l-lg" />
            </div>
            <div className="flex-1 pl-2 pt-0.5 flex flex-col gap-6">
              <Skeleton className="h-7 w-3/4" />
              <Skeleton className="h-7 w-20 rounded-l-lg" />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className={cardClasses({ variant: layoutVariant })}>
        <div className="relative w-full h-full rounded-md overflow-hidden">
          <Skeleton className="w-full h-full" />
        </div>
      </div>
    );
  };

  return (
    <div className={containerClasses({ variant: layoutVariant })}>
      {Array.from({ length: layoutVariant === 'list' ? 9 : 18 }).map((_, index) => (
        <GameCardSkeleton key={index} />
      ))}
    </div>
  );
}

export { LayoutSkeleton };
